import './index.scss';
import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';
import GLightbox from 'glightbox';

import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

var homepages = ['/', 'index.html', 'index.htm', 'index.php', 'main.html', 'main.htm', 'homepage.html', 'index2.htm'];
var largContainer = 0
let splide = false

document.addEventListener("DOMContentLoaded", function (event) { // init()
  init()
});



const init = function () {

  document.documentElement.classList.add('reveal-loaded')


  if (document.querySelector('.zone-cartes-haut')) initScroll()

    if (document.querySelector("h1")) {
      ScrollTrigger.create({
        trigger: document.querySelector("h1"),
        id: 2,
        start: 'top ',
        end: 'top 30%',
        onEnter: () => {
          document.querySelector("header").classList.add('is-active')
          document.querySelector(".header-mobile").classList.add('is-active')
        },
        onLeave: () => {
          //self => self.disable()
        },
        onLeaveBack: () => {
          document.querySelector("header").classList.remove('is-active')
          document.querySelector(".header-mobile").classList.remove('is-active')
        },
        markers: false
      })

    }

  if (document.querySelector('.accordion-container')) {
    new Accordion('.accordion-container');
  }

  if (document.querySelector('.minus')) {

    document.querySelector('.minus').addEventListener('click', function () {
      var input = document.querySelector('.nbr')
      var count = parseInt(input.value) - 1
      count = count < 1 ? 1 : count
      input.value = count
      return false
    })

    document.querySelector('.plus').addEventListener('click', function () {
      var input = document.querySelector('.nbr')
      var count = parseInt(input.value) + 1
      count = count > 14 ? 14 : count
      input.value = count
      return false
    })

    document.querySelector('.bouton-panier').addEventListener('click', function () {

      addCart()

    })


    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
  });

  
  
  }

  window.addEventListener("resize", setLargeurSplide)
  if (document.querySelector('.zone-videos .container')) largContainer = document.querySelector('.zone-videos .container').getBoundingClientRect()

  if (document.querySelector('#slide-videos')) {
    splide = new Splide('.splide', {
      type: 'loop',
      perPage: 3,
      arrows: false,
      autoHeight: true,
      padding: { right: (document.querySelector('.splide__slide').getBoundingClientRect().width) / 2 + 'px' },
      breakpoints: {
        1440: {
          perPage: 2,
        },
        1600: {
          perPage: 3,
        },
        640: {
          destroy: true,
        },
      }
    }).mount()

    setLargeurSplide()

    // splide.on('visible', function (e) {
    //   // do something
    //   console.log(e)
    // });
  }

  if (document.querySelector('#main-carousel')) {

        var splideProduit = new Splide( '#main-carousel', {
          pagination: false,
          arrows: false,
          video: {
            autoplay: true,
            loop: true,
            mute: true,
            hideControls: false,
            disableOverlayUI: true,
            playerOptions: {
              htmlVideo: {}
            },
          },
        } );
        
        var thumbnails = document.getElementsByClassName( 'thumbnail' );
        var current;
        
        for ( var i = 0; i < thumbnails.length; i++ ) {
          initThumbnail( thumbnails[ i ], i );
        }
        
        function initThumbnail( thumbnail, index ) {
          thumbnail.addEventListener( 'click', function () {
            splideProduit.go( index );
          } );
        }
        
        splideProduit.on( 'mounted move', function () {
          var thumbnail = thumbnails[ splideProduit.index ];
        
          if ( thumbnail ) {
            if ( current ) {
              current.classList.remove( 'is-active' );
            }
        
            thumbnail.classList.add( 'is-active' );
            current = thumbnail;
          }
        } );
        
        splideProduit.mount({ Video });
        

      }

}


const reveals = document.querySelectorAll('.reveal');
reveals.forEach((section, index) => {
  ScrollTrigger.create({
    trigger: section,
    id: index + 1,
    start: 'top 80%',
    end: 'bottom 80%',
    onEnter: () => {
      section.classList.remove('reveal')
    },
    onLeave: () => {
      self => self.disable()
    },
    onLeaveBack: self => self.disable(),
    markers: false // !! MARQUERUS
  })
})



const addCart = () => {
  var nbr = document.querySelector('.nbr').value
  window.location.replace('/?add-to-cart=111&quantity=' + nbr)
}

const setLargeurSplide = () => {

  if ((window.innerWidth > 640) && (document.querySelector('.zone-videos .container'))) {
    var largContainer = document.querySelector('.zone-videos .container').getBoundingClientRect()
    console.log((window.innerWidth - largContainer.width) / 2 + 'px')
    splide.options = {
      padding: { right: (document.querySelector('.splide__slide').getBoundingClientRect().width) / 2 + 'px' },
    }
    splide.refresh()
  
    var largVideoTexte = document.querySelector('.zone-videos-texte').getBoundingClientRect()
  
    console.log(largContainer.width, largVideoTexte.width, window.innerWidth)
  
    var largeur = (largContainer.width - largVideoTexte.width) + ((window.innerWidth - largContainer.width))
    document.querySelector('.splide').style.width = largeur + "px";
  
  }
  
}



const initScroll = () => {
  
  gsap.set(document.querySelector(".zone-cartes-haut"), { xPercent: -100 });
  gsap.to(document.querySelector(".zone-cartes-haut"), {
    xPercent: 100,
    //rotation: 360,
    scrollTrigger: {
      trigger: document.querySelector(".zone-cartes-haut"),
      start: "top 100%",
      end: "top 40%",
      scrub: true,
      //markers: true,
      id: "scrub"
    }
  });


  gsap.set(document.querySelector(".zone-cartes-bas"), { xPercent: 200 });
  gsap.to(document.querySelector(".zone-cartes-bas"), {
    xPercent: 0,
    //rotation: 360,
    scrollTrigger: {
      trigger: document.querySelector(".zone-cartes-bas"),
      start: "top 100%",
      end: "top 40%",
      scrub: true,
      //markers: true,
      id: "scrub"
    }
  });


  // if(window.innerWidth > 640) {
  //   gsap.set(".zone-cartes", { backgroundPosition: "0 150px" });

  //   gsap.to(".zone-cartes", {
  //     scrollTrigger: {
  //       trigger: ".zone-cartes-bas",
  //       start: "top 100%",
  //       end: "top 200px",
  //       scrub: true,
  //       // markers: true
  //     },
  //     backgroundPosition: "1000px 100px",
  //     ease: "none"
  //   });

  // }

  if (document.querySelector(".bouton-trigger")) {
    ScrollTrigger.create({
      trigger: document.querySelector(".bouton-trigger"),
      id: 1,
      start: 'top ',
      end: 'top 30%',
      onEnter: () => {
        document.querySelector("header").classList.add('is-active')
        document.querySelector(".header-mobile").classList.add('is-active')
      },
      onLeave: () => {
        //self => self.disable()
      },
      onLeaveBack: () => {
        document.querySelector("header").classList.remove('is-active')
        document.querySelector(".header-mobile").classList.remove('is-active')
      },
      markers: false
    })
  }




  document.querySelectorAll('.bouton-acheter-home').forEach(element => {
    element.addEventListener('click', function (e) {
      if (homepages.indexOf(window.location.pathname) >= 0) {
        e.preventDefault()
        if (window.innerWidth > 540) gsap.to(window, { duration: 1, scrollTo: { y: "#produit", offsetY: 100 } });
        else gsap.to(window, { duration: 1, scrollTo: { y: "#produit", offsetY: 0 } });
      }

    })
  });



}